import { render, staticRenderFns } from "./NewPay.vue?vue&type=template&id=09546ea9&scoped=true"
import script from "./NewPay.vue?vue&type=script&lang=js"
export * from "./NewPay.vue?vue&type=script&lang=js"
import style0 from "./NewPay.vue?vue&type=style&index=0&id=09546ea9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09546ea9",
  null
  
)

export default component.exports